import React, { useState, useEffect } from 'react';
import { ImageIcon } from 'lucide-react';
import { logoService } from '../services/api';

const ClubLogo = ({ className = "w-16 h-16 md:w-20 md:h-20", showFallback = true }) => {
  const [logoUrl, setLogoUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadLogo();
  }, []);

  const loadLogo = async () => {
    try {
      const response = await logoService.get();
      if (response.logo_url) {
        setLogoUrl(response.logo_url);
      }
    } catch (error) {
      console.error('Error loading club logo:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className={`${className} object-cover rounded-full shadow-md border-2 border-white bg-gray-100 flex items-center justify-center`}>
        <div className="w-6 h-6 border-2 border-gray-300 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (logoUrl) {
    return (
      <img 
        src={logoUrl} 
        alt="Logo du club" 
        className={`${className} object-cover rounded-full shadow-md border-2 border-white`}
      />
    );
  }

  // Fallback for clubs without logo
  if (showFallback) {
    return (
      <div className={`${className} bg-green-500 rounded-full shadow-md border-2 border-white flex items-center justify-center`}>
        <ImageIcon className="w-8 h-8 text-white" />
      </div>
    );
  }

  return null;
};

export default ClubLogo;